import 'scripts/bem'

// load the stylin
import '../_bundles/filters.css'

// load the common blocks
import * as blocks from '../_bundles/filters.js'

// load the run script
import Compiler from 'scripts/run.js'

Compiler.run(blocks)
